import { useAuthenticatedUser } from "hooks/useAuthenticatedUser";
import { useAuthorization } from "hooks/useAuthorization";
import { useCompany } from "hooks/useCompany";
import { useFeatureFlags } from "hooks/useFeatureFlags";

export const useSideNavVisibility = () => {
  const { user } = useAuthenticatedUser();
  const company = useCompany();
  const flags = useFeatureFlags();
  const { hasPermission, loading: authLoading } = useAuthorization("company", company?.id);

  const isAuthorizationResolved = !flags.enableOpenFgaAuthorization || !authLoading;

  const showAccessReviewSection = (
    flags.enableOpenFgaAuthorization
      ? hasPermission("can_see_sidenav_access_review_section")
      : Boolean(user?.isAdmin || user?.hasAccessReviewReports)
  ) && !!company?.enableAccessReviews;

  const showAdministrativeSection = flags.enableOpenFgaAuthorization
    ? hasPermission("can_see_sidenav_administrative_section")
    : Boolean(user?.isAdmin);

  const hasAnyPageAccess = flags.enableOpenFgaAuthorization
    ? user?.hasElevatedFgaRole
    : Boolean(user?.isAdmin);

  const showReporting = !!flags.enableReporting;

  return {
    hasAnyPageAccess,
    isAuthorizationResolved,
    showAccessReviewSection,
    showAdministrativeSection,
    showReporting,
  };
};
